import type { FC } from "react";
import { useId } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Dropdown, DropdownButton, DropdownItem } from "@similarweb/ui-components";

import { StyledBaseDropdownButtonWrap } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/common-styles";

import type { DeviceOption } from "../../types/commonFiltersDto";

import { StyledDeviceContainer } from "./styles";

type DeviceDropdownProps = {
    options: readonly DeviceOption[];
    value?: DeviceOption;
    onChange: (value: DeviceOption) => void;
};

const BASIC_DEVICE_TRANSLATE_ROUTE = "si.find_apps.filters.ios-download-and-engagement.device";

const DeviceDropdown: FC<DeviceDropdownProps> = ({ options, value, onChange }) => {
    const { translate } = useTranslate();
    const dropdownId = useId();

    const handleClick = (item: { id: DeviceOption }): void => {
        onChange(item.id);
    };

    const getDeviceTitle = (item: DeviceOption) => {
        return translate(`${BASIC_DEVICE_TRANSLATE_ROUTE}.${item}`);
    };

    return (
        <StyledDeviceContainer id={dropdownId}>
            <Dropdown
                appendTo={`#${CSS.escape(dropdownId)}`}
                onClick={handleClick}
            >
                <StyledBaseDropdownButtonWrap>
                    <DropdownButton>{translate(`${BASIC_DEVICE_TRANSLATE_ROUTE}.placeholder`)}</DropdownButton>
                </StyledBaseDropdownButtonWrap>
                {...options.map((item) => {
                    return (
                        <DropdownItem
                            id={item}
                            key={item}
                        >
                            {getDeviceTitle(item)}
                        </DropdownItem>
                    );
                })}
            </Dropdown>
        </StyledDeviceContainer>
    );
};

export default DeviceDropdown;
